import axios, { isAxiosError } from 'axios';

import type {
  GetApiV1ManageIssueResponse,
  PostApiV1ManageIssueAssignData,
  PostApiV1ManageIssueCloseData,
} from '~/api/generated';

export type CloseReasons = GetApiV1ManageIssueResponse['close_reasons'];
// Assign and unassign take the same body.
type IssueAssignment = NonNullable<PostApiV1ManageIssueAssignData['body']>;
type IssueClosure = NonNullable<PostApiV1ManageIssueCloseData['body']>;
export type GitlabIssueCheck = 'found' | 'not_found' | 'unreachable' | 'unverifiable';

const BASE_PATH = '/api/v1/manage_issue';

export async function fetchManageIssue(): Promise<GetApiV1ManageIssueResponse> {
  const { data } = await axios.get<GetApiV1ManageIssueResponse>(BASE_PATH);

  return data;
}

export async function assignIssue(assignment: IssueAssignment): Promise<void> {
  await axios.post(`${BASE_PATH}/assign`, assignment);
}

export async function unassignIssue(assignment: IssueAssignment): Promise<void> {
  await axios.post(`${BASE_PATH}/unassign`, assignment);
}

export async function closeIssue(closure: IssueClosure): Promise<void> {
  await axios.post(`${BASE_PATH}/close`, closure);
}

// GitLab's own API, so there is no generated type. Only whether it answers matters.
export async function verifyGitlabIssue(apiUrl: string): Promise<GitlabIssueCheck> {
  try {
    await axios.get(apiUrl);

    return 'found';
  } catch (error) {
    const status = isAxiosError(error) ? error.response?.status : undefined;

    if (status === undefined) {
      return 'unreachable';
    }

    return status === 404 ? 'not_found' : 'unverifiable';
  }
}
